module.exports = __webpack_public_path__ + "img/symbol_11_normal.e39255a2.png";